import {
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import {
  AccountCircle,
  Lock,
  Visibility,
  VisibilityOff
} from '@material-ui/icons';
import classnames from 'classnames';
import { InjectedFormikProps, withFormik } from 'formik';
import * as QueryString from 'query-string';
import * as React from 'react';
import * as Yup from 'yup';
import MyButton from '../../components/UI/MyButton/MyButton';
import history from '../../utilities/history';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    textField: {
      background: 'white',
      marginTop: '2rem',
      padding: '4px',
      borderRadius: 3,
      fontSize: '12px',
      fontWeight: 400
    },
    formWrapper: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 2rem'
    },
    title: {
      textTransform: 'uppercase',
      color: '#f8e200',
      padding: '1rem 2rem',
      fontWeight: 400
    },
    adornmentIcon: {
      color: 'grey'
    },
    signInButton: {
      backgroundColor: '#f8e200',
      padding: '0.5rem 1.5rem',
      '&:hover': {
        background: '#f8e200',
        opacity: 0.8
      },
      margin: '1rem 0 2rem 0',
      width: '100%'
    },
    btnWrapper: {
      display: 'flex',
      flexDirection: 'column',
      padding: '2rem',
      justifyContent: 'space-between'
    },
    error: {
      border: '2px solid #df041f'
    }
  });

interface IFormValues {
  email: string;
}

interface IForgotPasswordFormOwnProps {
  className?: any;
  onSubmit: any;
  closeShowPassword: () => void;
}

type IForgotPasswordFormProps = IForgotPasswordFormOwnProps &
  WithStyles<typeof styles>;

const InnerForm: React.SFC<
  InjectedFormikProps<IForgotPasswordFormProps, IFormValues>
> = props => {
  const { classes, className } = props;
  const params = QueryString.parse(history.location.search);
  return (
    <div className={classnames(classes.root, className)}>
      <form onSubmit={props.handleSubmit}>
        <Typography variant={'h6'} className={classes.title}>
          {'Forgot Password'}
        </Typography>
        <Divider style={{ background: 'grey' }} />
        <div className={classes.formWrapper}>
          <TextField
            className={classnames(classes.textField, {
              [classes.error]: Boolean(props.errors.email)
            })}
            placeholder={'Email'}
            name={'email'}
            id={'email'}
            InputProps={{
              startAdornment: (
                <InputAdornment
                  className={classes.adornmentIcon}
                  position="start"
                >
                  <AccountCircle />
                </InputAdornment>
              ),
              disableUnderline: true
            }}
            value={props.values.email}
            onChange={props.handleChange}
          />
          <Typography
            onClick={props.closeShowPassword}
            style={{
              color: '#f8e200',
              cursor: 'pointer',
              alignSelf: 'flex-end',
              marginTop: '0.5rem'
            }}
          >
            Back to Sign In
          </Typography>
          <Button className={classes.signInButton} type={'submit'}>
            {'Submit'}
          </Button>
        </div>
      </form>
    </div>
  );
};

const ForgotPasswordForm = withFormik<IForgotPasswordFormProps, IFormValues>({
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address!')
      .required('*Required')
  }),

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default withStyles(styles)(ForgotPasswordForm);
